module.exports = __webpack_public_path__ + "static/img/公司4.73168c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/公司4.jpg
// module id = E6Kr
// module chunks = 1